import React from 'react';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
import { Outlet, useLocation } from '@tanstack/react-router';
import { cn } from '../../lib/shadcn/utils';
import { AuthGuard } from '../../core/auth/AuthGuard';
import { isNativePlatform } from '../../core/platform-detection';

export function Layout() {
  const location = useLocation();
  const isCapacitor = isNativePlatform();

  // Check if current path should hide footer
  const shouldHideFooter =
    // Hide footer on Capacitor (native mobile)
    isCapacitor ||
    // Landing page (exact match)
    location.pathname === '/' ||
    // Reels route pattern: /itineraries/reels/{id}
    /^\/itineraries\/reels\/[^\/]+$/.test(location.pathname) ||
    // Individual itinerary view route pattern: /itineraries/{id} (but not edit routes)
    /^\/itineraries\/[^\/]+$/.test(location.pathname);

  return (
    <div
      className={cn(
        'flex flex-col bg-background overflow-hidden',
        // On mobile: h-dvh to constrain to dynamic viewport (respects safe areas and browser UI)
        // Content can still scroll naturally within the main element
        // On desktop: fixed viewport height for sidebar layout
        'h-dvh md:h-[100dvh]'
      )}
    >
      <Navbar />

      {/* 
        Mobile-first scrollable content area:
        - Mobile: flex-1 to fill remaining space after navbar, padding for bottom nav, overflow for scrolling
        - Desktop: Full height with left sidebar, scrollable container
        - Footer is inside scrollable area and pushed to bottom with flex
      */}
      <main
        className={cn(
          // Mobile: flex-1 to fill space, padding for bottom nav, allow scrolling
          'flex-1 pb-[calc(36px+env(safe-area-inset-bottom,0px))] overflow-y-auto',
          // Desktop: fixed height container with sidebar offset and scrollable
          'md:pb-0 md:pl-16'
        )}
      >
        <AuthGuard>
          <Outlet />
        </AuthGuard>
        {!shouldHideFooter && <Footer />}
      </main>
    </div>
  );
}
